import Input from './Input';
import TextAreaInput from './TextAreaInput';

export const TextInput = Input;
export const TextArea = TextAreaInput;
